import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		userInfo: JSON.parse(window.localStorage.getItem('userInfo') || 'null'),// 当前登录用状态
		fontSize: 15
	},
	getters: {},
	mutations: {
		setUserInfo(state, payload) {
			state.userInfo = JSON.parse(payload)
			window.localStorage.setItem('userInfo', payload)
		},
		setFontSize(state, payload) {
			state.fontSize = payload
		}
	},
	actions: {},
	modules: {}
})
